import React, { useMemo } from 'react';
import DOMPurify from 'dompurify';

const CleanHtml = ({ summaryHtml ,summaryRef}) => {
  // Sanitize only when `summaryHtml` changes
  const sanitizedHtml = useMemo(() => {
    return DOMPurify.sanitize(summaryHtml);
  }, [summaryHtml]);

  return (
    <div ref={summaryRef} dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />
  );
};

export default CleanHtml;
